module.exports = __webpack_public_path__ + "public/1.0.1_701555/img/up.ab94bf73.png";